import { View } from 'react-native';

import { Text } from '@/components/Text';
import Card from '@/components/ui/therapist/Card';
import { User } from '@/stores/store.types';

import { styles } from './styles';

interface PersonalInfoProps {
  user: User;
}

export const PersonalInfo: React.FC<PersonalInfoProps> = ({ user }) => {
  return (
    <Card
      iconPosition="outside"
      title="Persönliche Daten"
      icon="user"
      styleBody={{ padding: 0 }}
    >
      <View style={[styles.itemContainer, { paddingTop: 20 }]}>
        <Text style={styles.label}>Vorname</Text>
        <Text>{user.firstName}</Text>
      </View>
      <View style={styles.divider}></View>
      <View style={[styles.itemContainer, { paddingBottom: 20 }]}>
        <Text style={styles.label}>Name</Text>
        <Text>{user.lastName}</Text>
      </View>
    </Card>
  );
};
